import bustypes from "./bustypes.component";
import bustypesUrls from "./bustypes.urls";
import BustypesTransforms from "./bustypes.transforms";

const bustypesModule = angular
  .module("app.components.bustypes", [])
  .component("bustypesPage", bustypes)
  .service("BustypesTransforms", BustypesTransforms)
  .config(bustypesUrls);

export default bustypesModule;



// WEBPACK FOOTER //
// ./src/pages/bustypes/bustypes.module.js